import creditProfile1 from '../Static/creditBureauFiles/profile_1.json';
import creditProfile2 from '../Static/creditBureauFiles/profile_2.json';
import creditProfile3 from '../Static/creditBureauFiles/profile_3.json';
import creditProfile4 from '../Static/creditBureauFiles/profile_4.json';
import creditProfile5 from '../Static/creditBureauFiles/profile_5.json';
import { getPfmType } from './storageUtils';

const getProfile = () => {
  switch (getPfmType()) {
    case 'profile_1':
      return creditProfile1;
    case 'profile_2':
      return creditProfile2;
    case 'profile_3':
      return creditProfile3;
    case 'profile_4':
      return creditProfile4;
    case 'profile_5':
      return creditProfile5;
    default:
      return creditProfile1;
  }
};

export function getMonthWiseScores(): any[] {
  return getProfile().monthWiseScores;
}

export function getCurrentCreditScore(): number {
  return getProfile().monthWiseScores[getProfile().monthWiseScores.length - 1][
    'score'
  ];
}

export function getFactorValue(valueKey: string): any {
  const profile: any = getProfile().factors;
  return profile[valueKey];
}

export function getLoanData(): any[] {
  return getProfile().loanData;
}
